import type { WidgetCatalog } from '../ids';

/**
 * English — SOURCE, and the only catalogue compiled into the main bundle.
 *
 * It is eager because it is `WIDGET_DEFAULT_LOCALE`: the panel renders this while
 * a visitor's own language is still arriving, so there is never a frame of blank
 * labels on somebody else's page. Every other language is a chunk.
 *
 * Not a translation of Ukrainian and not translated FROM it — both are source
 * text, and the other forty-eight are translations of this one.
 */
const catalog: WidgetCatalog = {
  'widget.author.team': 'Support team',
  'widget.author.you': 'You',
  'widget.back': 'Back',
  'widget.close': 'Minimise chat',
  'widget.composer.hint': 'Enter to send, Shift+Enter for a new line',
  'widget.composer.placeholder': 'Write a message…',
  'widget.composer.send': 'Send',
  'widget.composer.sending': 'Sending…',
  'widget.consent.allow': 'Show it',
  'widget.consent.arrival_label': 'Where you came from',
  'widget.consent.decline': 'No thanks',
  'widget.consent.heading': 'What the agent sees',
  'widget.consent.intro':
    'We can show these to the agent so they need not ask. Saying no changes nothing — we will help just the same.',
  'widget.consent.page_label': 'The page you are on',
  'widget.consent.shared': 'Shared',
  'widget.consent.withdraw': 'Take it back',
  'widget.conversation.closed': 'This conversation is closed.',
  'widget.conversation.empty': 'Nothing here yet. Send the first message.',
  'widget.conversation.loading': 'Loading…',
  'widget.conversation.start_new': 'Start a new conversation',
  'widget.end_chat': 'End chat',
  'widget.end_chat.cancel': 'Keep chatting',
  'widget.end_chat.confirm': 'End this chat? You can always start a new one.',
  'widget.end_chat.yes': 'Yes, end it',
  'widget.error.retry': 'Try again',
  'widget.error.send_failed': 'The message was not sent.',
  'widget.error.unavailable': 'Chat is not available on this page.',
  'widget.error.unreachable': 'We could not reach the chat.',
  'widget.history': 'Past conversations',
  'widget.history.current': 'Current',
  'widget.history.empty': 'No past conversations yet.',
  'widget.history.no_messages': 'No messages',
  'widget.language': 'Language',
  'widget.launcher': 'Open chat',
  'widget.launcher_unread': 'Open chat — new messages',
  'widget.message.failed': 'Not sent',
  'widget.message.pending': 'Sending',
  'widget.prechat.intro': 'Tell us a little about yourself so we can reply.',
  'widget.prechat.optional': 'optional',
  'widget.prechat.submit': 'Start the conversation',
  'widget.select.placeholder': 'Choose…',
  'widget.status.closed': 'Closed',
  'widget.status.open': 'Open',
  'widget.status.resolved': 'Resolved',
  'widget.title': 'Chat',
  'widget.validation.choose': 'Choose one of the options.',
  'widget.validation.email': 'That does not look like an email address.',
  'widget.validation.required': 'This field is required.',
  'widget.validation.too_long': 'Too many characters.',
};

export default catalog;
